// Zone de déploiement (public.area) — le PRÉFIXE du code décide si un dossier se traite ou pas.
//
// ⚠️ DEUX CHAMPS PORTENT LE MÊME NOM, et ce n'est pas le même. `public.address.area_id` est un ENTIER
// (clé étrangère vers `public.area.id`, déjà exposé sous `DmpAddressAttributes.areaId`) ; le code que
// tout le monde appelle « area ID » est la colonne TEXTE `public.area.area_id`, de la forme
// « GF004-01-001 » / « UF… ». C'est ce texte-là qui est testé ici, jamais l'entier.
//
// Règle métier (user, 2026-09-03) : « si ça commence en GF je dois avoir un moyen de le voir
// rapidement, car on ne traite pas ce genre de ticket ». Sondé le même jour sur la prod : 260 zones,
// exactement DEUX préfixes — UF (146) et GF (114). La règle vit ici, et pas dans un écran, pour que la
// file, la fenêtre de validation et la fiche de la console DMP ne puissent pas en donner trois
// versions (même principe que constants/delivery-status.ts).
export const GF_AREA_PREFIX = 'GF';
/** Vrai quand le code de zone désigne une zone GF — ces dossiers ne sont pas traités par l'équipe AV.
 *  Faux sur null/undefined : une zone INCONNUE n'est pas une zone GF, et l'écran doit dire « inconnue »
 *  plutôt que de laisser croire qu'elle est UF. */
export function isGfArea(areaCode) {
    return !!areaCode && areaCode.trim().toUpperCase().startsWith(GF_AREA_PREFIX);
}
//# sourceMappingURL=area.js.map